import moment from 'moment-timezone';

/**
 * Returns UTC offset string for a timezone.
 * Example: "America/New_York" in EST -> "-05:00"
 */
export const getTimezoneOffset = (tzId: string): string => {
  return moment.tz(tzId).format('Z');
};
